import { DateTime } from 'luxon'
import store from '@/store'
const Currency = store.getters['getCompanyCurrency']

export function capitalize (s) {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function displayNumber (x, fraction=0) {
  if (x === null || x === undefined) return ''
  x = x.toFixed(fraction)
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x))
    if (Currency.code === 'IDR') {
      x = x.replace(pattern, "$1.$2");
    } else {
      x = x.replace(pattern, "$1,$2");
    }
  return `${x}`
}

export function displayPriceRM (x) {
  let price = displayNumber(x/100, 2)
  if (x < 0) {
    return `- RM ${price.replace('-', '')}`
  }
  return `RM ${price}`
}

export function displayPrice (x, data) {
  let currency = data
  if (!currency) {
    currency = Currency
  }
  let price = displayNumber(x/currency.multiplier, currency.exponent)
  if (x < 0) {
    return `- ${currency.symbol} ${price.replace('-', '')}`
  }
  return `${currency.symbol} ${price}`
}

export function displayPriceNoCent (x, data) {
  let currency = data
  if (!currency) {
    currency = Currency
  }
  let price = displayNumber(x/currency.multiplier, 0)
  if (x < 0) {
    return `- ${currency.symbol} ${price.replace('-', '')}`
  }
  return `${currency.symbol} ${price}`
}

export function displayNumberPrice (x, data) {
  let currency = data
  if (!currency) {
    currency = Currency
  }
  let price = displayNumber(x/currency.multiplier, 0)
  if (x < 0) {
    return `- ${price.replace('-', '')}`
  }
  return `${price}`
}

export function displayFormattedPrice (x, screenWidth) {
  const amount = x/Currency.multiplier
  var price = displayNumber(amount, Currency.exponent)
  if (Math.abs(amount) > 9999 && screenWidth < 600) {
    price = displayNumber(amount/1000, 1) + 'k'
  }
  if (Math.abs(amount) > 9999999) {
    price = displayNumber(amount/1000000, 1) + 'M'
  }
  if (x < 0) {
    return `- ${Currency.symbol} ${price.replace('-', '')}`
  }
  return `${Currency.symbol} ${price}`
}

export function encodeSymbols (message) {
  message = message.replace(/\./g, '%2E')
  message = message.replace(/&/g, '%26')
  message = message.replace(/\?/g, '%3F')
  message = message.replace(/#/g, '%23')
  message = message.replace(/</g, '%3C')
  message = message.replace(/>/g, '%3E')
  return message
}

export function displayPriceRaw (x) {
  x = (x/Currency.multiplier).toFixed(Currency.exponent)
  var pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(x))
      x = x.replace(pattern, "$1,$2");
  return `${x}`
}

export function titleCase (x) {
  if (!x) return ''
  return x.charAt(0).toUpperCase() + x.slice(1)
}

export function convertServerDate(value) {
  if (!value) return '-'
  const date = DateTime.fromISO(value)
  return `${date.toFormat('dd/MM/yyyy')} at ${date.toFormat('hh:mma')}`
}

export function convertServerDateWithZone(value, zone) {
  if (!value) return '-'
  const date = DateTime.fromISO(value, { zone: zone })
  return `${date.toFormat('dd/MM/yyyy')} at ${date.toFormat('hh:mma')}`
}

export function displayDate(value) {
  const date = DateTime.fromISO(value)
  return `${date.toFormat('dd/MM/yyyy')}`
}

export function displayDateWithZone(value, zone) {
  const date = DateTime.fromISO(value, { zone: zone })
  return `${date.toFormat('dd/MM/yyyy')}`
}

export function humanizeDate(value) {
  const date = DateTime.fromISO(value)
  return `${date.toFormat('dd')} ${date.monthShort} ${date.toFormat('yyyy')}`
}

export function humanizeDateLong(value) {
  const date = DateTime.fromISO(value)
  return `${date.toFormat('dd')} ${date.monthLong} ${date.toFormat('yyyy')}`
}


export function humanizeDateRange(value) {
  if (Array.isArray(value) && value.length > 0) {
    if (value.length > 1) {
      const date1 = DateTime.fromISO(value[0])
      const date2 = DateTime.fromISO(value[1])
      if (value[0] === value[1]) {
        return `${date1.toFormat('dd')} ${date1.monthShort} ${date1.toFormat('yyyy')}`
      }
      return `${date1.toFormat('dd')} ${date1.monthShort} - ${date2.toFormat('dd')} ${date2.monthShort} ${date2.toFormat('yyyy')}`
    } else {
      const date = DateTime.fromISO(value[0])
      return `${date.toFormat('dd')} ${date.monthShort} ${date.toFormat('yyyy')}`
    }
  }
  return ''
}

export function renewContractDate(value) {
  const date = DateTime.fromISO(value)
  return ` ${date.monthLong} ${date.toFormat('yyyy')}`
}

export function displayTime(value) {
  const date = DateTime.fromISO(value)
  return `${date.toFormat('hh:mma')}`
}

export function displayTime2(value) {
  const date = DateTime.fromISO(value)
  return `${date.toFormat('h:mm a')}`
}

export function leadStatusDisplay(status) {
  if (status === 'new') {
    return 'New'
  } else if (status === 'follow_up') {
    return 'Follow up'
  } else if (status === 'partial_payment') {
    return 'Partial paid'
  } else if (status === 'reject') {
    return 'Rejected'
  } else if (status === 'processed') {
    return 'Process'
  } else if (status === 'shipped') {
    return 'Shipped'
  } else if (status === 'received') {
    return 'Received'
  } else if (status === 'partial_payment') {
    return 'Partial payment'
  } else if (status === 'cancelled') {
    return 'Cancelled'
  } else if (status === '') {
    return 'All'
  }
  if (!status) return ''
  return status.charAt(0).toUpperCase() + status.slice(1)
}

export function leadStatusDisplayCRM(status) {
  if (status === 'new') {
    return 'New'
  } else if (status === 'follow_up') {
    return 'Nurture'
  } else if (status === 'partial_payment') {
    return 'Partial Payment'
  } else if (status === 'request') {
    return 'Scheduled'
  } else if (status === 'reject') {
    return 'Not Interested'
  } else if (status === 'processed') {
    return 'Invoice Sent'
  } else if (status === 'shipped') {
    return 'Paid'
  } else if (status === 'cancelled') {
    return 'Pending'
  } else if (status === '') {
    return 'All'
  }
  if (!status) return ''
  return status.charAt(0).toUpperCase() + status.slice(1)
}

export function leadStatusDisplayRenewal(status) {
  if (status === 'new') {
    return 'New'
  } else if (status === 'follow_up') {
    return 'Follow up'
  } else if (status === 'partial_payment') {
    return 'Demo'
  } else if (status === 'reject') {
    return 'Churn'
  } else if (status === 'processed') {
    return 'Renew'
  } else if (status === 'shipped') {
    return 'Upsell'
  } else if (status === '') {
    return 'All'
  }
  if (!status) return ''
  return status.charAt(0).toUpperCase() + status.slice(1)
}

export function leadStatusColor(status) {
  if (status === 'new') {
    return 'textColorAccent'
  } else if (status === 'follow_up') {
    return 'warning500'
  } else if (status === 'partial_payment') {
    return 'textColorHint'
  } else if (status === 'reject') {
    return 'danger500'
  } else if (status === 'processed') {
    return 'success500'
  } else if (status === 'shipped') {
    return 'warning500'
  } else if (status === 'received') {
    return 'textColorHint'
  } else if (status === 'cancelled') {
    return 'danger500'
  } else if (status === 'error') {
    return 'danger500'
  } else if (status === '') {
    return 'textColorHint'
  }
  return 'textColorHint'
}

export function shippingMethodDisplay(method) {
  if (method === 'easyparcel') {
    return 'EasyParcel'
  } else if (method === 'zepto') {
    return 'ZeptoExpress'
  } else if (method === 'lalamove') {
    return 'Lalamove'
  } else if (method === 'ys_localdelivery') {
    return 'Yezza Shipping'
  } else if (method === 'ys_courier') {
    return 'Yezza Shipping'
  } else if (method === '') {
    return 'Manual'
  }
  if (!method) return ''
  return method.charAt(0).toUpperCase() + method.slice(1)
}

export function paymentGatewayDisplay(gateway) {
  if (gateway === 'billplz') {
    return 'Billplz'
  } else if (gateway === 'yezzapay') {
    return 'Yezzapay'
  } else if (gateway === 'molpay') {
    return 'MOLPay'
  } else if (gateway === 'twoctwop') {
    return '2c2p'
  } else if (gateway === 'direct') {
    return 'Manual'
  } else if (gateway === '') {
    return 'Manual'
  }
  if (!gateway) return ''
  return gateway.charAt(0).toUpperCase() + gateway.slice(1)
}

export function payoutStatusColor(status) {
  if (status === 'new') {
    return 'accent'
  } else if (status === 'processed') {
    return 'black'
  } else if (status === 'completed') {
    return 'green'
  } else if (status === 'error') {
    return 'error'
  } else if (status === '') {
    return 'grey'
  }
  return 'grey'
}

export function percentage (x) {
  if (x === null || x === undefined) return ''
  x = (x * 100).toFixed(1)
  return `${x}%`
}

export function removePhoneAlias (phone) {
  if (!phone) {
    phone = ''
  }
  phone = phone.trim()
  if (phone.includes('+') && phone.charAt(0) !== '+') {
    let phoneComponents = phone.split('+')
    phone = phoneComponents[1]
  }
  phone = phone.trim().replace('-', '').replace(' ', '').replace('+', '')

  return phone
}

export function removePhoneAliasAndMYCountryCode (phone) {
  phone = removePhoneAlias(phone)
  if (phone.charAt(0) === '6') {
    phone = phone.substring(1)
  }
  return phone
}

export function phoneSanitized (phone) {
  phone = phone.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
  if (phone.charAt(0) === '0') {
    phone = '6' + phone
  }
  return phone
}

export function phoneFormat (phone) {
  if (phone) {
    let text = ''
    const dialCode = phone.substr(0,2)
    if (dialCode === '60') {
      text = `+${phone.substr(0, 1)} ${phone.substr(1)}`
    } else {
      text = `+${phone}`
    }
    return text
  } else {
    return null
  }
}

export function convertToHumanizeTime (value) {
  const current = new Date()
  const previous = DateTime.fromISO(value)
  const msPerMinute = 60 * 1000
  const msPerHour = msPerMinute * 60
  const msPerDay = msPerHour * 24
  const msPerWeek = msPerDay * 6
  const msPerMonth = msPerDay * 30
  const msPerYear = msPerDay * 365

  const elapsed = current - previous

  if (elapsed < msPerMinute) {
    if (Math.round(elapsed / 1000) === 0) {
      return 'Just now'
    }
    if (Math.round(elapsed / 1000) === 1) {
      return '1 second ago'
    }
    return Math.round(elapsed / 1000) + ' seconds ago'
  } else if (elapsed < msPerHour) {
    if (elapsed / msPerMinute < 2) {
      return 'A minute ago'
    }
    return Math.round(elapsed / msPerMinute) + ' minutes ago'
  } else if (elapsed < msPerDay) {
    if (elapsed / msPerHour < 2) {
      return 'An hour ago'
    }
    return Math.round(elapsed / msPerHour) + ' hours ago'
  } else if (elapsed > msPerWeek && elapsed < msPerMonth) {
    if (
      Math.round(elapsed / msPerMonth) === 1 &&
      Math.round(elapsed / msPerWeek) === 5
    ) {
      return 'Last month'
    } else if (elapsed / msPerWeek < 2) {
      return 'Last week'
    }
    return Math.round(elapsed / msPerWeek) + ' weeks ago'
  } else if (elapsed < msPerMonth) {
    if (elapsed / msPerDay < 2) {
      return 'Yesterday'
    }
    return Math.round(elapsed / msPerDay) + ' days ago'
  } else if (elapsed < msPerYear) {
    if (elapsed / msPerMonth < 2) {
      return 'Last month'
    }
    return Math.round(elapsed / msPerMonth) + ' months ago'
  }
  return new Date(previous.toMillis()).toDateString()
}

export function slugify (text) {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    // eslint-disable-next-line
    .replace(/[^\u0100-\uFFFF\w\-]/g, '-') // Remove all non-word chars ( fix for UTF-8 chars )
    // eslint-disable-next-line
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

export function getCountryCodeFromZoneId (timeZoneId) {
  const timeZone = timeZones.filter(f => f.includes(timeZoneId))[0]
  if (timeZone) {
    return timeZone.split(',')[0]
  }
  return 'MY'
}

const timeZones = ['AR,America/Argentina/San_Luis', 'AU,Australia/Sydney', 'RU,Europe/Moscow', 'KZ,Asia/Aqtobe', 'AL,Europe/Tirane', 'US,America/New_York', 'AR,America/Argentina/La_Rioja', 'UA,Europe/Zaporozhye', 'YT,Indian/Mayotte', 'RU,Europe/Volgograd', 'CI,Africa/Abidjan', 'AS,Pacific/Pago_Pago', 'RU,Asia/Yekaterinburg', 'AU,Australia/Darwin', 'CA,America/Atikokan', 'MX,America/Chihuahua', 'CA,America/Dawson_Creek', 'MQ,America/Martinique', 'RE,Indian/Reunion', 'AM,Asia/Yerevan', 'MV,Indian/Maldives', 'BS,America/Nassau', 'AR,America/Argentina/Salta', 'MX,America/Mexico_City', 'PN,Pacific/Pitcairn', 'OM,Asia/Muscat', 'IL,Asia/Jerusalem', 'RU,Asia/Vladivostok', 'PH,Asia/Manila', 'US,America/Phoenix', 'TH,Asia/Bangkok', 'GL,America/Danmarkshavn', 'CA,America/Creston', 'US,America/Menominee', 'RU,Asia/Novokuznetsk', 'BB,America/Barbados', 'PA,America/Panama', 'FI,Europe/Helsinki', 'CA,America/Goose_Bay', 'TF,Indian/Kerguelen', 'BY,Europe/Minsk', 'TW,Asia/Taipei', 'BR,America/Porto_Velho', 'MX,America/Tijuana', 'SS,Africa/Juba', 'MX,America/Mazatlan', 'FO,Atlantic/Faroe', 'RU,Europe/Simferopol', 'CA,America/Thunder_Bay', 'SY,Asia/Damascus', 'NL,Europe/Amsterdam', 'UM,Pacific/Wake', 'SV,America/El_Salvador', 'KR,Asia/Seoul', 'GG,Europe/Guernsey', 'CN,Asia/Kashgar', 'BR,America/Eirunepe', 'AU,Australia/Lord_Howe', 'CA,America/Glace_Bay', 'KN,America/St_Kitts', 'CY,Asia/Nicosia', 'BR,America/Santarem', 'RU,Asia/Novosibirsk', 'AD,Europe/Andorra', 'GT,America/Guatemala', 'RS,Europe/Belgrade', 'TT,America/Port_of_Spain', 'NR,Pacific/Nauru', 'CN,Asia/Harbin', 'PR,America/Puerto_Rico', 'QA,Asia/Qatar', 'AQ,Antarctica/DumontDUrville', 'UM,Pacific/Johnston', 'BR,America/Rio_Branco', 'US,America/Nome', 'NG,Africa/Lagos', 'VI,America/St_Thomas', 'SX,America/Lower_Princes', 'US,America/Indiana/Tell_City', 'FJ,Pacific/Fiji', 'CD,Africa/Kinshasa', 'MN,Asia/Choibalsan', 'PM,America/Miquelon', 'LK,Asia/Colombo', 'MX,America/Ojinaga', 'GN,Africa/Conakry', 'CA,America/Nipigon', 'KG,Asia/Bishkek', 'UA,Europe/Uzhgorod', 'HT,America/Port-au-Prince', 'AT,Europe/Vienna', 'GR,Europe/Athens', 'UA,Europe/Kiev', 'SO,Africa/Mogadishu', 'VG,America/Tortola', 'FM,Pacific/Pohnpei', 'HU,Europe/Budapest', 'BH,Asia/Bahrain', 'AU,Australia/Brisbane', 'SE,Europe/Stockholm', 'AR,America/Argentina/Cordoba', 'BL,America/St_Barthelemy', 'FR,Europe/Paris', 'AQ,Antarctica/Mawson', 'PG,Pacific/Port_Moresby', 'AU,Australia/Perth', 'US,America/Denver', 'AQ,Antarctica/Casey', 'BR,America/Manaus', 'CA,America/Resolute', 'MS,America/Montserrat', 'GF,America/Cayenne', 'AR,America/Argentina/Buenos_Aires', 'CA,America/Toronto', 'MX,America/Monterrey', 'AF,Asia/Kabul', 'ET,Africa/Addis_Ababa', 'BQ,America/Kralendijk', 'DJ,Africa/Djibouti', 'PF,Pacific/Tahiti', 'GL,America/Godthab', 'CN,Asia/Shanghai', 'RU,Asia/Magadan', 'AU,Australia/Lindeman', 'BN,Asia/Brunei', 'CA,America/Regina', 'US,America/Indiana/Knox', 'YE,Asia/Aden', 'CA,America/Winnipeg', 'US,America/Adak', 'MG,Indian/Antananarivo', 'GD,America/Grenada', 'US,America/Sitka', 'CA,America/Vancouver', 'MK,Europe/Skopje', 'VC,America/St_Vincent', 'CG,Africa/Brazzaville', 'KP,Asia/Pyongyang', 'MN,Asia/Hovd', 'BR,America/Araguaina', 'US,America/Boise', 'CA,America/Blanc-Sablon', 'JO,Asia/Amman', 'NZ,Pacific/Auckland', 'CA,America/Rankin_Inlet', 'CA,America/Swift_Current', 'RU,Asia/Anadyr', 'UZ,Asia/Tashkent', 'CA,America/Iqaluit', 'US,America/Los_Angeles', 'CR,America/Costa_Rica', 'FK,Atlantic/Stanley', 'RU,Asia/Yakutsk', 'GP,America/Guadeloupe', 'SJ,Arctic/Longyearbyen', 'BG,Europe/Sofia', 'JP,Asia/Tokyo', 'LA,Asia/Vientiane', 'CA,America/Rainy_River', 'US,America/Indiana/Winamac', 'CD,Africa/Lubumbashi', 'TJ,Asia/Dushanbe', 'NI,America/Managua', 'BR,America/Sao_Paulo', 'AZ,Asia/Baku', 'US,America/Anchorage', 'RU,Asia/Omsk', 'MZ,Africa/Maputo', 'BJ,Africa/Porto-Novo', 'LB,Asia/Beirut', 'NZ,Pacific/Chatham', 'US,America/Indiana/Marengo', 'EH,Africa/El_Aaiun', 'KM,Indian/Comoro', 'ST,Africa/Sao_Tome', 'TL,Asia/Dili', 'CA,America/Whitehorse', 'GU,Pacific/Guam', 'AQ,Antarctica/Palmer', 'NF,Pacific/Norfolk', 'BE,Europe/Brussels', 'AR,America/Argentina/Rio_Gallegos', 'KI,Pacific/Tarawa', 'SM,Europe/San_Marino', 'BR,America/Belem', 'BW,Africa/Gaborone', 'MX,America/Cancun', 'CN,Asia/Urumqi', 'BM,Atlantic/Bermuda', 'DE,Europe/Berlin', 'BA,Europe/Sarajevo', 'IE,Europe/Dublin', 'ES,Africa/Ceuta', 'FM,Pacific/Kosrae', 'AR,America/Argentina/San_Juan', 'MD,Europe/Chisinau', 'PT,Atlantic/Azores', 'BD,Asia/Dhaka', 'AG,America/Antigua', 'PT,Europe/Lisbon', 'MX,America/Santa_Isabel', 'LS,Africa/Maseru', 'TN,Africa/Tunis', 'BR,America/Maceio', 'AR,America/Argentina/Catamarca', 'BR,America/Cuiaba', 'AU,Antarctica/Macquarie', 'BR,America/Recife', 'RU,Europe/Samara', 'EC,America/Guayaquil', 'CA,America/Halifax', 'UG,Africa/Kampala', 'GH,Africa/Accra', 'FM,Pacific/Chuuk', 'PF,Pacific/Marquesas', 'AU,Australia/Eucla', 'SK,Europe/Bratislava', 'IT,Europe/Rome', 'ES,Atlantic/Canary', 'SC,Indian/Mahe', 'CO,America/Bogota', 'PY,America/Asuncion', 'US,America/Juneau', 'GI,Europe/Gibraltar', 'US,Pacific/Honolulu', 'VU,Pacific/Efate', 'CW,America/Curacao', 'MY,Asia/Kuala_Lumpur', 'MC,Europe/Monaco', 'CM,Africa/Douala', 'NP,Asia/Kathmandu', 'LT,Europe/Vilnius', 'SB,Pacific/Guadalcanal', 'PL,Europe/Warsaw', 'SL,Africa/Freetown', 'IR,Asia/Tehran', 'US,America/Metlakatla', 'TR,Europe/Istanbul', 'CK,Pacific/Rarotonga', 'MN,Asia/Ulaanbaatar', 'TK,Pacific/Fakaofo', 'CH,Europe/Zurich', 'BI,Africa/Bujumbura', 'AU,Australia/Melbourne', 'AQ,Antarctica/Troll', 'HR,Europe/Zagreb', 'WS,Pacific/Apia', 'SI,Europe/Ljubljana', 'MY,Asia/Kuching', 'JE,Europe/Jersey', 'IN,Asia/Kolkata', 'EC,Pacific/Galapagos', 'US,America/Kentucky/Louisville', 'RU,Asia/Krasnoyarsk', 'SD,Africa/Khartoum', 'BT,Asia/Thimphu', 'AQ,Antarctica/Vostok', 'IM,Europe/Isle_of_Man', 'AI,America/Anguilla', 'KY,America/Cayman', 'CC,Indian/Cocos', 'MT,Europe/Malta', 'AW,America/Aruba', 'DO,America/Santo_Domingo', 'MM,Asia/Rangoon', 'MX,America/Matamoros', 'ML,Africa/Bamako', 'GB,Europe/London', 'PF,Pacific/Gambier', 'GE,Asia/Tbilisi', 'IO,Indian/Chagos', 'RU,Asia/Sakhalin', 'KZ,Asia/Oral', 'TZ,Africa/Dar_es_Salaam', 'HK,Asia/Hong_Kong', 'AR,America/Argentina/Tucuman', 'CZ,Europe/Prague', 'PW,Pacific/Palau', 'EG,Africa/Cairo', 'TV,Pacific/Funafuti', 'AU,Australia/Hobart', 'ZM,Africa/Lusaka', 'LC,America/St_Lucia', 'TC,America/Grand_Turk', 'CN,Asia/Chongqing', 'BR,America/Boa_Vista', 'ZW,Africa/Harare', 'JM,America/Jamaica', 'MF,America/Marigot', 'US,America/North_Dakota/Beulah', 'CU,America/Havana', 'GL,America/Thule', 'US,America/Indiana/Petersburg', 'ID,Asia/Makassar', 'US,America/Indiana/Vevay', 'GY,America/Guyana', 'NU,Pacific/Niue', 'ES,Europe/Madrid', 'AE,Asia/Dubai', 'TG,Africa/Lome', 'WF,Pacific/Wallis', 'US,America/North_Dakota/New_Salem', 'SA,Asia/Riyadh', 'SG,Asia/Singapore', 'LV,Europe/Riga', 'AQ,Antarctica/Rothera', 'BZ,America/Belize', 'AO,Africa/Luanda', 'KZ,Asia/Almaty', 'RO,Europe/Bucharest', 'CF,Africa/Bangui', 'AQ,Antarctica/McMurdo', 'CL,Pacific/Easter', 'TO,Pacific/Tongatapu', 'KI,Pacific/Enderbury', 'NO,Europe/Oslo', 'VN,Asia/Ho_Chi_Minh', 'US,America/Detroit', 'CA,America/Pangnirtung', 'LI,Europe/Vaduz', 'ZA,Africa/Johannesburg', 'AR,America/Argentina/Mendoza', 'KZ,Asia/Qyzylorda', 'GQ,Africa/Malabo', 'CA,America/Edmonton', 'MA,Africa/Casablanca', 'MU,Indian/Mauritius', 'ID,Asia/Jayapura', 'KH,Asia/Phnom_Penh', 'SR,America/Paramaribo', 'GA,Africa/Libreville', 'CA,America/St_Johns', 'CA,America/Inuvik', 'AU,Australia/Currie', 'SZ,Africa/Mbabane', 'RU,Asia/Kamchatka', 'EE,Europe/Tallinn', 'US,America/Chicago', 'US,America/Kentucky/Monticello', 'CV,Atlantic/Cape_Verde', 'KW,Asia/Kuwait', 'MR,Africa/Nouakchott', 'RU,Europe/Kaliningrad', 'BR,America/Fortaleza', 'LY,Africa/Tripoli', 'TD,Africa/Ndjamena', 'AQ,Antarctica/Syowa', 'BF,Africa/Ouagadougou', 'MH,Pacific/Majuro', 'RU,Asia/Irkutsk', 'TM,Asia/Ashgabat', 'GL,America/Scoresbysund', 'UY,America/Montevideo', 'AX,Europe/Mariehamn', 'US,America/Indiana/Indianapolis', 'PS,Asia/Gaza', 'BO,America/La_Paz', 'SN,Africa/Dakar', 'AR,America/Argentina/Ushuaia', 'NC,Pacific/Noumea', 'GW,Africa/Bissau', 'US,America/North_Dakota/Center', 'DK,Europe/Copenhagen', 'ID,Asia/Pontianak', 'US,America/Yakutat', 'MX,America/Hermosillo', 'VA,Europe/Vatican', 'CA,America/Dawson', 'ME,Europe/Podgorica', 'MO,Asia/Macau', 'PE,America/Lima', 'PT,Atlantic/Madeira', 'CA,America/Moncton', 'BR,America/Bahia', 'VE,America/Caracas', 'PS,Asia/Hebron', 'CL,America/Santiago', 'ID,Asia/Jakarta', 'US,America/Indiana/Vincennes', 'MX,America/Bahia_Banderas', 'KZ,Asia/Aqtau', 'BR,America/Noronha', 'CX,Indian/Christmas', 'AU,Australia/Broken_Hill', 'AU,Australia/Adelaide', 'MW,Africa/Blantyre', 'AR,America/Argentina/Jujuy', 'RU,Asia/Khandyga', 'NE,Africa/Niamey', 'SH,Atlantic/St_Helena', 'CA,America/Cambridge_Bay', 'MX,America/Merida', 'DZ,Africa/Algiers', 'LR,Africa/Monrovia', 'MP,Pacific/Saipan', 'ER,Africa/Asmara', 'LU,Europe/Luxembourg', 'CA,America/Yellowknife', 'NA,Africa/Windhoek', 'IS,Atlantic/Reykjavik', 'RU,Asia/Ust-Nera', 'UZ,Asia/Samarkand', 'DE,Europe/Busingen', 'GS,Atlantic/South_Georgia', 'KE,Africa/Nairobi', 'BR,America/Campo_Grande', 'GM,Africa/Banjul', 'IQ,Asia/Baghdad', 'AQ,Antarctica/Davis', 'HN,America/Tegucigalpa', 'PK,Asia/Karachi', 'UM,Pacific/Midway', 'DM,America/Dominica', 'KI,Pacific/Kiritimati', 'RW,Africa/Kigali', 'MH,Pacific/Kwajalein']

export function truncate(text, length, clamp) {
  clamp = clamp || '...'
  let node = document.createElement('div')
  node.innerHTML = text
  let content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}

/**
 * Filter the object based on allowed properties
 * @param {Object} obj Object to be filtered
 * @param {Array} allowedProperties Properties to allow
 * @param {Object} options
 * @param {Object} options.renamingKeys renaming keys object { currentKey: newKey }
 * @param {Boolean} options.allowNullUndefined to allow null or undefined
 * @returns {Object} filtered object
 */
export function filterAllowedObjectProperties(obj, allowedProperties = [], options = {}) {
  const { renamingKeys = {}, allowNullUndefined = true } = options
  return Object.keys(obj).reduce((next, key) => {
    if (allowedProperties.includes(key)) {
      let result = { ...next, [key]: obj[key] }
      if (renamingKeys[key]) {
        result = { ...next, [renamingKeys[key]]: obj[key] }
      }
      if (!allowNullUndefined && obj[key] == null) {
        return next
      }
      return result
    } else {
      return next
    }
  }, {})
}

/**
 * Filter the object based on disallowed properties
 * @param {Object} obj Object to be filtered
 * @param {Array} disallowedProperties Properties to disallow
 * @param {Object} options
 * @param {Object} options.renamingKeys renaming keys object { currentKey: newKey }
 * @param {Boolean} options.allowNullUndefined to allow null or undefined
 * @returns {Object} filtered object
 */
export function filterDisallowedObjectProperties(obj, disallowedProperties = [], options = {}) {
  const { renamingKeys = {}, allowNullUndefined = true } = options
  return Object.keys(obj).reduce((next, key) => {
    if (!disallowedProperties.includes(key)) {
      let result = { ...next, [key]: obj[key] }
      if (renamingKeys[key]) {
        result = { ...next, [renamingKeys[key]]: obj[key] }
      }
      if (!allowNullUndefined && obj[key] == null) {
        return next
      }
      return result
    } else {
      return next
    }
  }, {})
}


export function fieldNameDisplay(name) {
  switch (name.toLowerCase()) {
    case 'marital_status':
      return 'Marital status'
    case 'total_paid':
      return 'Total contribution'
    case 'phone':
        return 'Phone Number'
    default:
      return capitalize(name.toLowerCase())
  }
}

export function twoDigitTime(value) {
  return value < 10 ? `0${value}` : value
}

export function convertToRelativeCalendar(value) {
  const isoTime = DateTime.fromISO(value)
  
  return isoTime.toRelativeCalendar()
}

/**
 * Return word in pluralize form is more than 1
 * 
 * @param {string} word Word to pluralize
 * @param {count} count Counter for the word, default is 1 
 * @param {esForm} esForm The word has es for plural. Ex: Status --> Statuses 
 * @returns String
 */
export function pluralize(word, { count=1, esForm=false }) {
  return esForm ? `${word}${count > 1 ? 'es' : ''}` : `${word}${count > 1 ? 's' : ''}`
}

export function convertToDateOnly(value) {
  const isoDateTime = DateTime.fromISO(value)
  return isoDateTime.toFormat('dd MMM yyyy')
}

export function convertToTimeOnly(value) {
  const isoDateTime = DateTime.fromISO(value)
  return isoDateTime.toFormat('hh:mm a').toLowerCase()
}

export function initialCharacters(value) {
  let name = value
  let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu')
  let initials = [...name.matchAll(rgx)] || []
  initials = ((initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')).toUpperCase()
  return initials
}

export function getMemberName(value) {
  const user = value?.user
  return user ? `${user.first_name} ${user.last_name}` : ''
}